import { atom } from 'recoil';
import { persistAtom } from '../../common/recoil/persistAtom';

const getKey = (postfix: string) => `warebee-schedule-${postfix}`;

export const scheduleDockCostControlsState = persistAtom<boolean>({
  key: getKey('dock-cost-controls'),
  default: false,
});

export const scheduleDockStatsState = persistAtom<boolean>({
  key: 'state-scheduler-dock-stats',
  default: false,
});

export const scheduleHiddenDocksState = persistAtom<string[]>({
  key: 'state-scheduler-hidden-docks',
  default: [],
  effects: [
    ({ setSelf }) => {
      // Clear corrupted localStorage data if it exists and is not an array
      try {
        const stored = localStorage.getItem('state-scheduler-hidden-docks');
        if (stored) {
          const parsed = JSON.parse(stored);
          if (!Array.isArray(parsed)) {
            console.warn(
              'scheduleHiddenDocksState: Clearing corrupted localStorage data:',
              parsed,
            );
            localStorage.removeItem('state-scheduler-hidden-docks');
            setSelf([]);
          }
        }
      } catch (error) {
        console.warn(
          'scheduleHiddenDocksState: Error parsing localStorage, clearing:',
          error,
        );
        localStorage.removeItem('state-scheduler-hidden-docks');
        setSelf([]);
      }
    },
  ],
});

export const showDockStatsSidebarState = persistAtom<boolean>({
  key: 'state-show-dock-stats-sidebar',
  default: false,
});

export const scheduleHoveredJobId = atom<string | null>({
  key: getKey('hovered-job-id'),
  default: null,
});
